
import axiosClient from "../../../api/axiosClient";

const BASE_URL = "/api/trading/quotations";

const tradingQuotationService = {
  getQuotations(params = {}) {
    return axiosClient.get(BASE_URL, { params });
  },

  getQuotation(quotationId) {
    return axiosClient.get(`${BASE_URL}/${quotationId}`);
  },

  createQuotation(payload) {
    return axiosClient.post(BASE_URL, payload);
  },

  updateQuotation(quotationId, payload) {
    return axiosClient.put(`${BASE_URL}/${quotationId}`, payload);
  },

  submitForApproval(quotationId, payload) {
    return axiosClient.post(
      `${BASE_URL}/${quotationId}/submit-for-approval`,
      payload
    );
  },

  // Download quotation PDF
  downloadQuotationPdf(quotationId) {
    return axiosClient.get(`${BASE_URL}/${quotationId}/pdf`, {
      responseType: "blob",
    });
  },

  // Get terms already saved against a quotation
  getQuotationTerms(quotationId) {
    return axiosClient.get(`${BASE_URL}/${quotationId}/terms`);
  },

  // Get active terms from the quotation Terms & Conditions master
  getActiveQuotationTerms() {
    return axiosClient.get(`${BASE_URL}/terms/active`);
  },

  // Save selected Terms & Conditions against a quotation
  saveQuotationTerms(quotationId, terms) {
    return axiosClient.put(`${BASE_URL}/${quotationId}/terms`, {
      terms,
    });
  },

  getAuditHistory(quotationId) {
    return axiosClient.get(
      `${BASE_URL}/${quotationId}/audit-history`
    );
  },

  createRevision(quotationId, revisionReason) {
    return axiosClient.post(
      `${BASE_URL}/${quotationId}/revisions`,
      {
        revision_reason: revisionReason,
      }
    );
  },

  getCommunications(quotationId) {
    return axiosClient.get(
      `${BASE_URL}/${quotationId}/communications`
    );
  },

  markSentToCustomer(quotationId, payload = {}) {
    return axiosClient.post(
      `${BASE_URL}/${quotationId}/mark-sent-to-customer`,
      payload
    );
  },

  recordCustomerDecision(quotationId, payload) {
    return axiosClient.post(
      `${BASE_URL}/${quotationId}/customer-decision`,
      payload
    );
  },
};

export default tradingQuotationService;
